export const lensAbi_vault_contract = [{
    "inputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "name": "rewardTokenAmountsPerBlock",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
}];

export const lensAbi_xvs_contract = [{
    "inputs": [{ "internalType": "address", "name": "account", "type": "address" }],
    "name": "balanceOf",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
}];

export const lensAbi_vai_contract = [{
    "inputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "name": "balanceOf",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
}];

export const lensAbi_balances = [
    {
        "constant": false,
        "inputs": [{ "internalType": "contract VToken", "name": "vToken", "type": "address" },
        { "internalType": "address payable", "name": "account", "type": "address" }],
        "name": "vTokenBalances",
        "outputs": [{
            "components": [{
                "internalType": "address",
                "name": "vToken", "type": "address"
            },
            { "internalType": "uint256", "name": "balanceOf", "type": "uint256" },
            { "internalType": "uint256", "name": "borrowBalanceCurrent", "type": "uint256" },
            { "internalType": "uint256", "name": "balanceOfUnderlying", "type": "uint256" },
            { "internalType": "uint256", "name": "tokenBalance", "type": "uint256" },
            { "internalType": "uint256", "name": "tokenAllowance", "type": "uint256" }],
            "internalType": "struct VenusLens.VTokenBalances", "name": "", "type": "tuple"
        }],
        "payable": false, "stateMutability": "nonpayable", "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            { "internalType": "contract VToken[]", "name": "vTokens", "type": "address[]" },
            { "internalType": "address payable", "name": "account", "type": "address" }],
        "name": "vTokenBalancesAll",
        "outputs": [{
            "components": [{ "internalType": "address", "name": "vToken", "type": "address" },
            { "internalType": "uint256", "name": "balanceOf", "type": "uint256" },
            { "internalType": "uint256", "name": "borrowBalanceCurrent", "type": "uint256" },
            { "internalType": "uint256", "name": "balanceOfUnderlying", "type": "uint256" },
            { "internalType": "uint256", "name": "tokenBalance", "type": "uint256" },
            { "internalType": "uint256", "name": "tokenAllowance", "type": "uint256" }],
            "internalType": "struct VenusLens.VTokenBalances[]", "name": "", "type": "tuple[]"
        }],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    }];

    export const lens_abi = [
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "poolRegistryAddress",
                    "type": "address"
                }
            ],
            "name": "getAllPools",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "string",
                            "name": "name",
                            "type": "string"
                        },
                        {
                            "internalType": "address",
                            "name": "creator",
                            "type": "address"
                        },
                        {
                            "internalType": "address",
                            "name": "comptroller",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "blockPosted",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "timestampPosted",
                            "type": "uint256"
                        },
                        {
                            "internalType": "string",
                            "name": "category",
                            "type": "string"
                        },
                        {
                            "internalType": "string",
                            "name": "logoURL",
                            "type": "string"
                        },
                        {
                            "internalType": "string",
                            "name": "description",
                            "type": "string"
                        },
                        {
                            "internalType": "address",
                            "name": "priceOracle",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "closeFactor",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "liquidationIncentive",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "minLiquidatableCollateral",
                            "type": "uint256"
                        },
                        {
                            "components": [
                                {
                                    "internalType": "address",
                                    "name": "vToken",
                                    "type": "address"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "exchangeRateCurrent",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "supplyRatePerBlock",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "borrowRatePerBlock",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "reserveFactorMantissa",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "supplyCaps",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "borrowCaps",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "totalBorrows",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "totalReserves",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "totalSupply",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "totalCash",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "bool",
                                    "name": "isListed",
                                    "type": "bool"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "collateralFactorMantissa",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "address",
                                    "name": "underlyingAssetAddress",
                                    "type": "address"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "vTokenDecimals",
                                    "type": "uint256"
                                },
                                {
                                    "internalType": "uint256",
                                    "name": "underlyingDecimals",
                                    "type": "uint256"
                                }
                            ],
                            "internalType": "struct PoolLens.VTokenMetadata[]",
                            "name": "vTokens",
                            "type": "tuple[]"
                        }
                    ],
                    "internalType": "struct PoolLens.PoolData[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract VToken[]",
                    "name": "vTokens",
                    "type": "address[]"
                }
            ],
            "name": "vTokenUnderlyingPriceAll",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "address",
                            "name": "vToken",
                            "type": "address"
                        },
                        {
                            "internalType": "uint256",
                            "name": "underlyingPrice",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct PoolLens.VTokenUnderlyingPrice[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
    ]
    